import React from "react";
import { BackIcon, ChevronRightIcon, FileTextIcon } from "./icons";
import InlineTripPanel from "./InlineTripPanel";

const ActionDetailView = ({
  t,
  action,
  onBack,
  tripFormDraft,
  onTripFormChange,
  onTripFormSubmit,
  onCloseTripRequest,
  tripFormSaving,
  tripFormError,
}: any) => {
  const Icon = action?.icon || FileTextIcon;
  const tone = action?.tone || "info";
  const details = Array.isArray(action?.details)
    ? action.details.filter(Boolean)
    : [];

  return (
    <div className="pp-actions-app-view pp-actions-detail-view">
      <button type="button" className="pp-actions-back-button" onClick={onBack}>
        <BackIcon aria-hidden="true" />
        <span>{t("common.back", { defaultValue: "Back" })}</span>
      </button>

      <section className={`pp-actions-detail-card is-${tone}`}>
        <div className="pp-actions-detail-top">
          <span className="pp-actions-detail-icon" aria-hidden="true">
            <Icon />
          </span>
          <div className="pp-actions-detail-copy">
            {action?.eyebrow && (
              <span className="pp-actions-eyebrow">
                <span className="pp-actions-eyebrow-dot" />
                {action.eyebrow}
              </span>
            )}
            <h2>{action?.title}</h2>
            {action?.subtitle && <p>{action.subtitle}</p>}
          </div>
        </div>

        {details.length > 0 && (
          <div className="pp-actions-detail-meta">
            {details.map((detail: any, index: number) => (
              <span key={index}>{detail}</span>
            ))}
          </div>
        )}

        {action?.description && (
          <p className="pp-actions-detail-description">{action.description}</p>
        )}

        {action?.kind === "trip" &&
        action?.request &&
        !action.request?.approveOnly ? (
          <InlineTripPanel
            t={t}
            request={action.request}
            form={tripFormDraft}
            onChange={onTripFormChange}
            onSubmit={onTripFormSubmit}
            onCancel={() => {
              onCloseTripRequest?.();
              onBack?.();
            }}
            submitting={tripFormSaving}
            error={tripFormError}
          />
        ) : action?.actionLabel ? (
          <button
            type="button"
            className="pp-actions-detail-primary"
            onClick={action.onAction}
          >
            {action.actionLabel}
            <ChevronRightIcon aria-hidden="true" />
          </button>
        ) : null}
      </section>
    </div>
  );
};



export default ActionDetailView;
